// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__N6HLN","small":"Tag_small__uejPS","BLUE":"Tag_BLUE__6mShG"};